const Version = (window as any).env.VERSION;

export default Version;



// WEBPACK FOOTER //
// ./src/views/Framework/Constants/Version.tsx